module.exports = __webpack_public_path__ + "static/media/KP.43a969ae.svg";